// extracted by mini-css-extract-plugin
module.exports = {"subMenuTitle":"_1NJf3"};